/* eslint-disable */
import React from "react";
import GradientCard from "@/components/common/GradientCard";
import { IconVariants } from "@next-platform/client-common-spicy-ui";

const CHARACTER_CREATION_PERKS = [
  {
    ICON: IconVariants.EARTH,
    TITLE: "Create Public Chatbots",
    DESCRIPTION:
      "Showcase your imaginative characters to a wide audience and share your creative chatbots with the community. Gain recognition and get a chance to win each month in our Creator Showcase!",
  },
  {
    ICON: IconVariants.EYE_OFF,
    TITLE: "Create Private Chatbots",
    DESCRIPTION:
      "Create personalized chatbots for private conversations tailored to your deepest fantasies. Perfect for confidential discussions or exclusive interactions where customization is key.",
  },
  {
    ICON: IconVariants.TROPHY,
    TITLE: "Get Rewards",
    DESCRIPTION:
      "With each character you create, you have the chance to earn exclusive rewards, gain recognition, and even see yourself be featured each month in our Creator Showcase!",
  },
];

const CreateCharacterPerksSection = (): React.JSX.Element => (
  <div className="flex flex-row gap-8 justify-center items-center mb-8 flex-wrap">
    {CHARACTER_CREATION_PERKS.map((perk, index) => (
      <GradientCard key={index} icon={perk.ICON} title={perk.TITLE} description={perk.DESCRIPTION} />
    ))}
  </div>
);

export default CreateCharacterPerksSection;
